import React,{useEffect, useState, useRef, useMemo} from 'react';
import parse from 'html-react-parser'
import './galleryVN.css';
import cross from'../../images/cross.png'
import { playMusic, pauseMusic, setVolume, transitionVolume, stopMusic, isPlaying, playEffects, setVolumeEffects } from '../musicEngine/musicEngine';
import whoosh from'../../m/whoosh.js'
import click from'../../m/click.js'
import menu from'../../m/menu.js'
import failed from'../../m/failed.js'
import shiny from'../../m/shiny.js'
import ryderFootJobSkirtUpSpanked from'../../images/ryderFootJobSkirtUpSpanked.mp4'
import classroomMainCut_bg_presentation2_17 from'../../images/classroomMainCut_bg_presentation2_17.mp4'

function GalleryVN({goMenu, gallery, language, hzAdjuster}) {
  const [fullImg, setFullImg] = useState();
  const [fullVid, setFullVid] = useState();
  const [fullImg2, setFullImg2] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const [unlockButton, setUnlockButton] = useState(false);
  const [opac, setOpac] = useState(0);
  const [opacUnlock, setOpacUnlock] = useState(0);
  const [opacVid, setOpacVid] = useState(0);
  const wrap = useRef(null);
  const fullImgRef = useRef(null);
  const fullVidRef = useRef(null);
  const fullVideoRef = useRef(null);
  const unlockButtonRef = useRef(null);
  const thisGallery = useRef([]);


  let textTranslation = {
      en:{
        gallery:"Gallery",
        moreScenes:"More scenes are already available on my",
        unlock:"🗝️UNLOCK GALLERY🗝️",
        code:'The code is available for free on <a href="https://www.patreon.com/posts/gallery-unlock-153514304" target="_blank">my Patreon</a>',
      },
      ru:{
        gallery:"Галерея",
        moreScenes:"Больше контента уже доступно на моем",
        unlock:"🗝️РАЗБЛОКИРОВАТЬ🗝️",
        code:'Код доступен бесплатно на <a href="https://www.patreon.com/posts/gallery-unlock-153514304" target="_blank">Patreon</a>',
      }
    }

useEffect(() => {
//navigator.app.overrideButton("backbutton", true);
//document.addEventListener("backbutton", goToMenu)

//return () => window.removeEventListener("backbutton", goToMenu);
});

useEffect(() => {
  if(unlockButton){
  let passRef = document.getElementById("pass");
  document.addEventListener('deviceready', deviceReadyFunc, false);
  passRef.addEventListener('input', checkPass, false);

  async function checkPass() {
    if(passRef.value.length == 5){
      let value = hash(passRef.value.toUpperCase());
      console.log(value);
      if(value === "79329331"){
        setVolumeEffects(0.3);
        playEffects(shiny, false);
        passRef.blur();
        passRef.style.color="#04db28";
        for(let i = 0; i<thisGallery.current.length;i++){
          if(thisGallery.current[i][1] == "0"){
            thisGallery.current[i][1] = "1";
            gallery.current[i][1] = "1";
          }
        }
          localStorage.setItem('gallerySC', JSON.stringify(gallery.current));
        await changeSetting(unlockButtonRef,"current.style.opacity", 0, "", 0.02);
        unlockButtonRef.current.style.display = "none";
        setUnlockButton(false);
      }else{
        setVolumeEffects(0.5);
        playEffects(failed, false);
        passRef.style.color="#f52a2d";
        await changeSetting(passRef,"style.paddingLeft", 43, "px", 0.2);
        await changeSetting(passRef,"style.paddingLeft", 37, "px", 0.2);
        changeSetting(passRef,"style.paddingLeft", 40, "px", 0.5);
      }
    }else if(passRef.value.length < 5){
      passRef.style.color="#fff";
    }
  }
  }
  function deviceReadyFunc() {
    document.addEventListener('backbutton', onBackButton, false);
  }
  function onBackButton(e) {
    e.preventDefault();
    goToMenu();
  }
  return () => {
    document.removeEventListener('deviceready', deviceReadyFunc, false);
    document.removeEventListener('backbutton', onBackButton, false);
  }
},[]);

  useEffect(() => {
    async function start(){
    await changeSetting(wrap,"current.style.opacity", 0, "", 0.02);
    wrap.current.style.zIndex = 0;
    if(!isPlaying){
      setVolume(0);
      playMusic(menu, 2000);
    }
    setTimeout(async () => {
    await transitionVolume(0.8,1200);
  }, 100);
      }
      setTimeout(start, 300);
},[]);

useMemo(() => {
  let chapterNum = 3;
  let actualNum = 0;
  let recordSlice;
  let blurred = 0;
for(let i =0;i<gallery.current.length;i++){
  if(gallery.current[i][1] == "0"){
    blurred++;
  }
  if(gallery.current[i][1].includes("Chapter")){
    actualNum++;
    recordSlice = i;
    if(actualNum>chapterNum){
      break;
    }
  }
}
if(blurred !== 0){
setUnlockButton(true);
}
thisGallery.current= [...gallery.current];
if(actualNum>chapterNum){
thisGallery.current.splice(recordSlice);
}
},[]);

function waitingFunc(t){
  return new Promise(async (resolve, reject) => {
      setTimeout(f,t);
    function f(){
      resolve();
      return;
    }
  });
}

function waitVideoReady(video) {
  if (!(video instanceof HTMLVideoElement)) return Promise.reject(new TypeError('video required'));
  const HAVE_ENOUGH = HTMLMediaElement.HAVE_ENOUGH_DATA;
  if (video.readyState >= HAVE_ENOUGH) return Promise.resolve();
  return new Promise(async (resolve, reject) => {
    let loaded = false;
    while(!loaded) {
checkifPicLoaded();
await waitingFunc(8);
}
resolve();
function checkifPicLoaded(){
  if (video.readyState >= HAVE_ENOUGH) {
    loaded=true;
  }
}
  });
}

function hash(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return hash+"";
}

async function openUnlock(){
  if(!isChecked){
    setVolumeEffects(0.5);
    playEffects(click, false);
    document.getElementById("fullScreenOpac").style.display = "block";
    setIsChecked(true);
    await changeOnOff(false, setOpacUnlock);
    await waitingFunc(300);
    document.getElementById("pass").focus();
  }
}

async function closeUnlock(){
  setVolumeEffects(0.5);
  playEffects(click, false);
  setIsChecked(false);
  await changeOnOff(true, setOpacUnlock);
  document.getElementById("fullScreenOpac").style.display = "none";
}

async function openVid(e){
  setVolumeEffects(0.5);
  playEffects(click, false);
  fullVideoRef.current.src = e.target.src;
  await waitVideoReady(fullVideoRef.current);
  document.getElementById("fullVid").style.display = "block";
  await changeOnOff(false, setOpacVid);
  fullVidRef.current.onclick = closeVid;
}

async function closeVid(){
  setVolumeEffects(0.5);
  playEffects(click, false);
  await changeOnOff(true, setOpacVid);
  document.getElementById("fullVid").style.display = "none";
  fullVideoRef.current.src = undefined;
  fullVidRef.current.onclick = null;
}

async function openImg(e){
  setVolumeEffects(0.5);
  playEffects(click, false);
  setFullImg(e.target.src);
  if(thisGallery.current[e.target.name] && thisGallery.current[e.target.name][3]){
    setFullImg2(thisGallery.current[e.target.name][3]);
  }
  await changeOnOff(false, setOpac);
  fullImgRef.current.onclick = closeImg;
}

async function closeImg(){
  setVolumeEffects(0.5);
  playEffects(click, false);
  await changeOnOff(true, setOpac);
  setFullImg(undefined);
  setFullImg2(undefined);
  fullImgRef.current.onclick = null;
}


  async function goToMenu(){
    wrap.current.style.zIndex = 15;
    await transitionVolume(0,300);
    setVolumeEffects(0.5);
    playEffects(whoosh, false);
    await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
    goMenu();
  }

  /*function changeSetting(obj, setting, changeTo, um, speed, char){
    return new Promise((resolve, reject) => {
      const props = setting
          .split(/[./[\]]/g)
          .filter(p => p);
      const prop = props.pop();
      const parent = props.reduce((result, key) => result[key], obj);
      //
      var i;
      if(setting == "current.style.transform" || setting == "style.transform"){
        i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
      }else{
        i = Math.round(parseFloat(parent[prop]));
      }
      let slowDownTrigger = 0;
      let slower = 8;
      change();
    function change(){
      if(i>changeTo){
        i-=speed;
        if(i<changeTo){
          i = changeTo;
          if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
            parent[prop] = "scale("+i+")";
          }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
            parent[prop] = "rotateY("+i+"deg)";
          }else{
            parent[prop] = i+um;
          }
          resolve();
          return;
        }
    }else if(i<changeTo){
      i+=speed;
      if(i>changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
    }else{
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
  setTimeout(change, slower);
  return;
  }
  });
}*/

function changeSetting(obj, setting, changeTo, um, speed, char, float, stopLoading){
  speed=speed*2.3*hzAdjuster;
  return new Promise((resolve, reject) => {
    const props = setting
        .split(/[./[\]]/g)
        .filter(p => p);
    const prop = props.pop();
    const parent = props.reduce((result, key) => result[key], obj);
    var i;
    if(setting == "current.style.transform" || setting == "style.transform"){
      if(float){
        i = parseFloat(parent[prop].split("(")[1].split(")")[0]);
      }else{
        i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
      }
    }else if(setting == "current.style.filter" || setting == "style.filter"){
      if(float){
        i = parseFloat(parent[prop].split("(")[1].split("px)")[0]);
      }else{
        i = Math.round(parseFloat(parent[prop].split("(")[1].split("px)")[0]));
      }
    }else{
      if(float){
      i = parseFloat(parent[prop]);
      }else{
      i = Math.round(parseFloat(parent[prop]));
      }
    }
    let slowDownTrigger = 0;
    let slower = 8;
    change();
  function change(){
    if(i>changeTo){
      i-=speed;
      if(i<=changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else if((setting == "current.style.filter" || setting == "style.filter")){
          parent[prop] = "blur("+i+"px)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
  }else if(i<changeTo){
    i+=speed;
    if(i>=changeTo){
      i = changeTo;
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else if((setting == "current.style.filter" || setting == "style.filter")){
        parent[prop] = "blur("+i+"px)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
  }else{
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else if((setting == "current.style.filter" || setting == "style.filter")){
      parent[prop] = "blur("+i+"px)";
    }else{
      parent[prop] = i+um;
    }
    resolve();
    return;
  }
  if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
    parent[prop] = "scale("+i+")";
  }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
    parent[prop] = "rotateY("+i+"deg)";
  }else if((setting == "current.style.filter" || setting == "style.filter")){
    parent[prop] = "blur("+i+"px)";
  }else{
    parent[prop] = i+um;
  }
requestAnimationFrame(change);
return;
}
});
}

  function changeOnOff(toLow, setter){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.03;
      setter(op);
      setTimeout(ChangetoLow, 5);
    }else{
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.018;
    setter(op);
    setTimeout(change, 5);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }


return(
<div className='menu'>
{fullImg && <div className="fullScreen" style={{opacity:opac}}>
<img onClick={closeImg} src={cross} style={{cursor:"pointer"}}/>
<div ref={fullImgRef}><img src={fullImg}/><img src={fullImg2}/></div></div>
}
<div className="fullScreen" id="fullVid" style={{opacity:opacVid, display:"none"}}>
<img onClick={closeVid} src={cross} style={{cursor:"pointer"}}/>
<div ref={fullVidRef}><video ref={fullVideoRef} style={{cursor:"pointer"}} autoPlay loop muted playsInline></video></div></div>
{unlockButton && <><div className="fullScreen" onClick={closeUnlock} id="fullScreenOpac" style={{opacity:opacUnlock, display:"none", zIndex:12, backgroundColor: "rgba(0, 0, 0, 0.4)"}}><img   src={cross} style={{cursor:"pointer"}}/></div> <div className="unlockButton" ref={unlockButtonRef} style={{display:"flex", opacity:"1"}} onClick={openUnlock}><input type="checkbox" id="unlock" checked={isChecked} readOnly/><span>{textTranslation[language]["unlock"]}</span><input type="text" id="pass" maxLength="5" style={{paddingLeft:"40px"}} className="pass"/><p>{parse(textTranslation[language]["code"])}</p></div></>}
<div className="switchVN">
<div className="arrowBack" style={{position:"absolute",top:"-10px", left:"2vw"}} onClick={goToMenu}>
    <div></div>
</div>
<h2>{textTranslation[language]["gallery"]}</h2>
</div>
<div className='clickWrap' id='wrap' ref={wrap} style={{opacity:1,zIndex:15}}></div>
<div className="galleryBlurTopVN"></div>
<div className="galleryBlurBottomVN"></div>
<div className="galleryVN">
{thisGallery.current && thisGallery.current.map((item,index)=>{
  if(item[1] === "1" && item[0].includes(".mp4")){
    return (
  <div className='image' onClick={openVid} style={{cursor:"pointer"}} key={index}>{item[0] && <video autoPlay loop muted playsInline src={item[0]}></video>}</div>
  );
  }else if(item[1] === "1" && !item[0].includes(".mp4")){
  return (
    <div className='image' onClick={openImg} style={{cursor:"pointer"}} key={index}>{item[0] && <img src={item[0]} name={index} draggable="false"/>} {item[3] && <img src={item[3]} draggable="false"/>}</div>
  )
}else if(item[1].includes('Chapter')){
  let chapTxt;
  if(language == "ru"){
    chapTxt = "Глава " + item[1].split("Chapter ")[1];
  }else{
    chapTxt = item[1];
  }
    return (
<div className="chap"><h2 style={{color:"#fff"}} key={index}>{chapTxt}</h2></div>
);
}else if(item[1] !== "1" && item[0].includes(".mp4")){
  return (
<div className='image' key={index}>{item[0] && <video src={item[0]} autoPlay loop muted playsInline className='blur'></video>}<div className="lock">🔒</div></div>
);
}else if(item[1] !== "1" && !item[0].includes(".mp4")){
  return (
    <div className='image' key={index}>{item[0] && <img src={item[0]} className='blur' draggable="false"/>} {item[3] && <img src={item[3]} className='blur' draggable="false"/>}<div className="lock">🔒</div></div>
  )
}
})}

<div className='image'><div><p>{textTranslation[language]["moreScenes"]}</p><a href='https://www.patreon.com/c/almondraf' target="_blank"><div className="buttonPatreonGallery">PATREON</div></a></div><video autoPlay loop muted playsInline src={ryderFootJobSkirtUpSpanked} className='blurT'></video></div>
<div className='image'><div><p>{textTranslation[language]["moreScenes"]}</p><a href='https://www.patreon.com/c/almondraf' target="_blank"><div className="buttonPatreonGallery">PATREON</div></a></div><video autoPlay loop muted playsInline src={classroomMainCut_bg_presentation2_17} className='blurT'></video></div>

{/*<div className='image'><div><p>More scenes are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={juliaBathTeasing} className='blurT'/></div>}
{<div className='image'><div><p>More scenes are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={juliaSpankedAss} className='blurT'/></div>}
{<div className='image'><div><p>More scenes are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img80} className='blurT'/></div>}
{<div className='image'><div><p>More scenes are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img95} className='blurT'/></div>}
{<div className='image'><div><p>More scenes are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img91} className='blurT'/></div>}
*/}
</div>
</div>
);

}

export default GalleryVN;
